import Image from 'next/image';
import Link from 'next/link';
import { useEffect } from "react";
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';
export default function contentsBox(props) {
  // 모듈러 링크 리액트 hook
  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);
  //link로그를
  const handleClick = (a, b) => {
    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    let contentId;
    let contentTitle;
    let contentType;
    if (b === 'vod') {
      contentId = props.data.mda_id
      contentTitle = props.data.title;
      contentType = 'V';
    } else if (b === 'clip') {
      contentId = props.data.mda_id
      contentTitle = props.data.title;
      contentType = 'C';
    } else {
      contentId = props.data.mda_id;
      contentTitle =props.data.pc_img_attr;
      contentType = 'PH';
    }

    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: '', //모듈 아이디 없으면
        moduleTitle: '상단영역', //모듈 제목 (Require)
        moduleSubTitle: '콘텐츠형', //모듈 서브제목
        moduleActive: 'C', //콘텐츠 선택 정보 Click: C, Hover: H
        moduleSeq: 0, //페이지에서 해당 모듈의 위치
        moduleItemSeq: props.currentSlide, //모듈 내에서 콘텐츠의 위치
        programId: props.data.pgm_id, //프로그램의 아이디 (추가)
        programTitle: props.data.pgm_nm, //프로그램의 아이디 (추가)
        contentId: contentId,//식별자
        contentTitle: contentTitle, //콘텐츠의 제목  (Require)
        contentType: contentType, //콘텐츠의 타입 (별도 표 참조)
      }
    });
  };

  return (
    <div className="swiper-slide slide-slide">
      <div className="swiper-cont">
        {
          (props.data.type === 'photo') ?
            <div className={`spotModuleWrap_ContentPhoto ${props.data.title == '' || props.data.title == null ? 'spotModuleWrap_freeType3' : ''}`}>
              {

                props.data.link_url == null || props.data.link_url == '' ?
                  (
                    <>
                      <div className="spotModuleLink">
                        <span className="spotModuleImage_w">
                          <img src={props.data.m_img_url} className="spotModuleImg" alt={props.data.m_img_attr} />
                          {/* <Image src={props.data.m_img_url} className="spotModuleImg" layout='fixed' width={335} height={187} quality={props.data.m_img_attr || 75} alt={props.data.m_img_attr} /> */}
                        </span>
                        <div className="spotProgramCont">
                          <strong className="spotProgram-Title">{props.data.title}</strong>
                        </div>
                      </div>
                    </>
                  )
                  :
                  (
                    <>
                      <a href={props.data.link_url} >
                        <a onClick={(e) => handleClick(e, 'photo')} target={props.data.link_new_yn === 'Y' ? '_blank' : ''} href={props.data.link_url} className="spotModuleLink">
                          <span className="spotModuleImage_w">
                            <img src={props.data.m_img_url} className="spotModuleImg" alt={props.data.m_img_attr} />
                            {/* <Image src={props.data.m_img_url} className="spotModuleImg" layout='fixed' width={335} height={187} quality={props.data.m_img_attr || 75} alt={props.data.m_img_attr} /> */}
                          </span>
                          <div className="spotProgramCont">
                            <strong className="spotProgram-Title">{props.data.title}</strong>
                          </div>
                        </a>
                      </a>
                    </>
                  )
              }
            </div>
            : (props.data.type === 'vod') ?
              <div className="spotModuleWrap_ContentVod" >

                {

                  props.data.link_url == null || props.data.link_url == '' ?
                    (
                      <>
                        <div className="spotModuleLink">
                          <span className="spotModuleImage_w">
                            <img src={props.data.m_img_url} className="spotModuleImg" alt={props.data.m_img_attr} />
                            {/* <Image src={props.data.m_img_url} className="spotModuleImg" layout='fixed' width={335} height={187} quality={props.data.m_img_attr || 75} alt={props.data.m_img_attr} /> */}
                            <span className="iconModuleInfo-iconPlay"><span className="iconSvg_play"><i className="hide">재생</i></span></span>
                          </span>
                          <div className="spotProgramCont">
                            <strong className="spotProgram-Title">{props.data.title}</strong>
                            <span className="spotProgram-ProgName">{props.data.srs_no}회 {props.data.pgm_nm}</span>
                          </div>
                        </div>
                      </>
                    )
                    :
                    (
                      <>
                        <Link href={props.data.link_url} >
                          <a onClick={(e) => handleClick(e, 'vod')} target={props.data.link_new_yn === 'Y' ? '_blank' : ''} href={props.data.link_url} className="spotModuleLink">
                            <span className="spotModuleImage_w">
                              <img src={props.data.m_img_url} className="spotModuleImg" alt={props.data.m_img_attr} />
                              {/* <Image src={props.data.m_img_url} className="spotModuleImg" layout='fixed' width={335} height={187} quality={props.data.m_img_attr || 75} alt={props.data.m_img_attr} /> */}
                              <span className="iconModuleInfo-iconPlay"><span className="iconSvg_play"><i className="hide">재생</i></span></span>
                            </span>
                            <div className="spotProgramCont">
                              <strong className="spotProgram-Title">{props.data.title}</strong>
                              <span className="spotProgram-ProgName">{props.data.srs_no}회 {props.data.pgm_nm}</span>
                            </div>
                          </a>
                        </Link>
                      </>
                    )
                }
              </div> :
              <div className="spotModuleWrap_ContentClip">
                {

                  props.data.link_url == null || props.data.link_url == '' ?
                    (
                      <>
                        <div className="spotModuleLink">
                          <span className="spotModuleImage_w">
                            <img src={props.data.m_img_url}
                              className="spotModuleImg" alt={props.data.m_img_attr} />
                            {/* <Image src={props.data.m_img_url} className="spotModuleImg" layout='fixed' width={335} height={187} quality={props.data.m_img_attr || 75} alt={props.data.m_img_attr} /> */}
                            <span className="iconModuleInfo-cliptime"><span className="iconModule-text">{props.data.plytm}</span></span>
                          </span>
                          <div className="spotProgramCont">
                            <strong className="spotProgram-Title">{props.data.title}</strong>
                          </div>
                        </div>
                      </>
                    )
                    :
                    (
                      <>
                        <Link href={props.data.link_url} >
                          <a onClick={(e) => handleClick(e, 'clip')} target={props.data.link_new_yn === 'Y' ? '_blank' : ''} href={props.data.link_url} className="spotModuleLink">
                            <span className="spotModuleImage_w">
                              <img src={props.data.m_img_url}
                                className="spotModuleImg" alt={props.data.m_img_attr} />
                              {/* <Image src={props.data.m_img_url} className="spotModuleImg" layout='fixed' width={335} height={187} quality={props.data.m_img_attr || 75} alt={props.data.m_img_attr} /> */}
                              <span className="iconModuleInfo-cliptime"><span className="iconModule-text">{props.data.plytm}</span></span>
                            </span>
                            <div className="spotProgramCont">
                              <strong className="spotProgram-Title">{props.data.title}</strong>
                            </div>
                          </a>
                        </Link>
                      </>
                    )
                }

              </div>
        }
      </div>
    </div >
  )
}